import { ReactNode } from 'react'
import { Navigate } from 'react-router'

import { useAuth } from '@features/auth'

import { URL_MAIN_PAGE } from '@shared/contants'

export default function PrivateRoute ({ children }: { children: ReactNode }) {
  const { isAuthorized, loading } = useAuth()

  if (!loading && !isAuthorized) {
    return <Navigate to={URL_MAIN_PAGE} />
  }

  return children
}
